'use client';

import Link from 'next/link';
import { useRouter } from 'next/navigation';

interface AdminErrorPageProps {
  statusCode: string;
  title: string;
  message: string;
}

export function AdminErrorPage({ statusCode, title, message }: AdminErrorPageProps) {
  const router = useRouter();

  return (
    <main className="admin-error-shell">
      <section className="admin-error-card" aria-labelledby="admin-error-title">
        <div className="admin-error-badge">{statusCode}</div>
        <h1 id="admin-error-title">{title}</h1>
        <p>{message}</p>
        <div className="admin-error-actions">
          <Link href="/" className="admin-error-primary">
            Home
          </Link>
          <button type="button" className="admin-error-secondary" onClick={() => router.back()}>
            Go Back
          </button>
        </div>
      </section>
    </main>
  );
}
